<sag-ui-table
    [columns]="columns"
    [data]="data"
    [config]="config"
    [rowMenuActions]="rowMenuActions"
    [paginationPageSize]="paginationPageSize"
    [pageSizeOptions]="pageSizeOptions"
></sag-ui-table>
